import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext, useFieldArray } from 'react-hook-form';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';
import CheckboxIcon from '@wix/da-ds/pkg/Icons/16x16/Checkbox';
import RadioIcon from '@wix/da-ds/pkg/Icons/16x16/Radio';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import AnswerChoiceField from './AnswerChoiceField';
import { AnswerType, QuestionFieldName } from '../../types';

import s from './AnswerChoicesGroupField.scss';

interface Props {
  answerType: AnswerType;
}

const AnswerChoicesGroupField: React.FC<Props> = ({ answerType }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { fields, append } = useFieldArray({
    control,
    name: QuestionFieldName.ANSWER_CHOICES,
  });

  const inputPrefix =
    answerType === AnswerType.SINGLE_CHOICE ? (
      <RadioIcon size={IconSize.SMALL} disableDefaultColors />
    ) : (
      <CheckboxIcon size={IconSize.SMALL} disableDefaultColors />
    );

  return (
    <div className={s['root']}>
      {fields.map((field, index) => (
        <AnswerChoiceField
          key={field.id}
          field={field}
          index={index}
          inputPrefix={inputPrefix}
        />
      ))}
      <TextButton
        variant="main"
        size="medium"
        icon={AddIcon}
        onClick={() => append({})}
      >
        {t('customExclusivePopup.questionnaire.form.addAnswer')}
      </TextButton>
    </div>
  );
};
AnswerChoicesGroupField.displayName = 'AnswerChoicesGroupField';

export default AnswerChoicesGroupField;
